import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { fetchData } from '../../apiService';
import withSessionCheck from '../../withSessionCheck';
import {
    CalendarMonth,
    TrendingUp,

    AccessTime,
    PersonAdd,
    LocalHospital,
    AttachMoney,

    Refresh,
    People,
    MedicalServices,
    Schedule,
    CheckCircle,
    PendingActions,



    Circle,
    PlayArrow,

    Add,
    KeyboardArrowRight,
    WbSunny,
    NightsStay,

    Bolt,

} from '@mui/icons-material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { CircularProgress, Fade, Tooltip, Avatar, IconButton, LinearProgress } from '@mui/material';

const Home = () => {
    const { companyName, username, roleName, companyId, token } = useAuth();
    const history = useHistory();
    const [mounted, setMounted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [currentTime, setCurrentTime] = useState(new Date());



    const [dashboardData, setDashboardData] = useState({
        todayAppointments: 0,
        completedAppointments: 0,
        pendingAppointments: 0,
        cancelledAppointments: 0,
        totalPatients: 0,
        newPatientsToday: 0,
        todayRevenue: 0,
        monthlyRevenue: 0,
        totalDoctors: 0,
        activeTreatments: 0
    });

    const [recentAppointments, setRecentAppointments] = useState([]);
    const [upcomingAppointments, setUpcomingAppointments] = useState([]);
    const [recentPatients, setRecentPatients] = useState([]);


    // Real-time clock
    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        setMounted(true);
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const today = new Date().toISOString().split('T')[0];

            // Fetch appointments
            const appointmentsRes = await fetchData('AppointmentApi', `/${companyId}`, token);
            if (appointmentsRes.responseCode === '1111') {
                const allAppts = appointmentsRes.response_data || [];
                const todayAppts = allAppts.filter(apt => apt.AppointmentDate?.split('T')[0] === today);
                const completed = todayAppts.filter(apt => apt.Status === 'Completed' || apt.IsCompleted);
                const pending = todayAppts.filter(apt => !apt.Status || apt.Status === 'Pending' || apt.Status === 'Scheduled');
                const cancelled = todayAppts.filter(apt => apt.Status === 'Cancelled');

                // Calculate revenue
                const todayRev = todayAppts.reduce((sum, apt) => sum + (parseFloat(apt.Amount) || 0), 0);
                const monthlyRev = allAppts.reduce((sum, apt) => sum + (parseFloat(apt.Amount) || 0), 0);

                setDashboardData(prev => ({
                    ...prev,
                    todayAppointments: todayAppts.length,
                    completedAppointments: completed.length,
                    pendingAppointments: pending.length,
                    cancelledAppointments: cancelled.length,
                    todayRevenue: todayRev,
                    monthlyRevenue: monthlyRev
                }));

                // Sort by time for upcoming
                const sortedAppts = [...todayAppts].sort((a, b) => 
                    (a.AppointmentTime || '').localeCompare(b.AppointmentTime || '')
                );
                setRecentAppointments(sortedAppts.slice(0, 6));
                setUpcomingAppointments(sortedAppts.filter(apt => !apt.IsCompleted).slice(0, 4));
            }

            // Fetch patients
            const patientsRes = await fetchData('PatientApi', `/${companyId}`, token);
            if (patientsRes.responseCode === '1111') {
                const patients = patientsRes.response_data || [];
                const newToday = patients.filter(p => p.CreatedDate?.split('T')[0] === today);
                setDashboardData(prev => ({
                    ...prev,
                    totalPatients: patients.length,
                    newPatientsToday: newToday.length
                }));
                setRecentPatients(patients.slice(-5).reverse());
            }

            // Fetch doctors
            const doctorsRes = await fetchData('DoctorApi', `/${companyId}`, token);
            if (doctorsRes.responseCode === '1111') {
                setDashboardData(prev => ({
                    ...prev,
                    totalDoctors: doctorsRes.response_data?.length || 0
                }));
            }



        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        } finally {
            setLoading(false);
        }
    };



    const getGreeting = () => {
        const hour = currentTime.getHours();
        if (hour < 12) return { text: 'Good Morning', icon: <WbSunny style={{ color: '#fbbf24' }} /> };
        if (hour < 17) return { text: 'Good Afternoon', icon: <WbSunny style={{ color: '#f97316' }} /> };
        return { text: 'Good Evening', icon: <NightsStay style={{ color: '#8b5cf6' }} /> };
    };

    const greeting = getGreeting();

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0
        }).format(amount);
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed': return '#10b981';
            case 'pending': case 'scheduled': return '#f59e0b';
            case 'cancelled': return '#ef4444';
            case 'in-progress': return '#3b82f6';
            default: return '#6b7280';
        }
    };

    const completionRate = dashboardData.todayAppointments > 0 
        ? Math.round((dashboardData.completedAppointments / dashboardData.todayAppointments) * 100) 
        : 0;

    return (
        <Fade in={mounted} timeout={600}>
            <div style={{ 
                minHeight: '100vh', 
                //background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)', 
                padding: '4px 8px',
                position: 'relative',
                marginTop: '-24px'
            }}>
                <style>{`
                    @keyframes slideUp {
                        from { opacity: 0; transform: translateY(30px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes slideRight {
                        from { opacity: 0; transform: translateX(-30px); }
                        to { opacity: 1; transform: translateX(0); }
                    }
                    @keyframes scaleIn {
                        from { opacity: 0; transform: scale(0.9); }
                        to { opacity: 1; transform: scale(1); }
                    }
                    @keyframes pulse {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.6; }
                    }
                    @keyframes shimmer {
                        0% { background-position: -200% 0; }
                        100% { background-position: 200% 0; }
                    }
                    @keyframes float {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-5px); }
                    }
                    @keyframes glow {
                        0%, 100% { box-shadow: 0 0 5px rgba(102, 126, 234, 0.5); }
                        50% { box-shadow: 0 0 20px rgba(102, 126, 234, 0.8); }
                    }
                    .glass-card {
                        background: rgba(255, 255, 255, 0.9);
                        backdrop-filter: blur(20px);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
                    }
                    .stat-card {
                        animation: slideUp 0.6s ease-out forwards;
                        opacity: 0;
                        cursor: pointer;
                        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                    }
                    .stat-card:hover {
                        transform: translateY(-8px) scale(1.02);
                        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                    }
                    .stat-card:nth-child(1) { animation-delay: 0.1s; }
                    .stat-card:nth-child(2) { animation-delay: 0.15s; }
                    .stat-card:nth-child(3) { animation-delay: 0.2s; }
                    .stat-card:nth-child(4) { animation-delay: 0.25s; }
                    .quick-action {
                        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                        position: relative;
                        overflow: hidden;
                    }
                    .quick-action::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
                        transition: left 0.5s;
                    }
                    .quick-action:hover::before {
                        left: 100%;
                    }
                    .quick-action:hover {
                        transform: translateY(-4px) scale(1.03);
                        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
                    }
                    .appointment-row {
                        transition: all 0.3s ease;
                        cursor: pointer;
                    }
                    .appointment-row:hover {
                        background: linear-gradient(135deg, #667eea10 0%, #764ba210 100%);
                        transform: translateX(5px);
                    }
                    .live-indicator {
                        animation: pulse 2s infinite;
                    }
                    .progress-ring {
                        transition: stroke-dashoffset 1s ease-out;
                    }

                    .floating-action {
                        animation: float 3s ease-in-out infinite;
                    }
                    .gradient-text {
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                    }
                `}</style>

                {/* ===== HERO HEADER WITH LIVE CLOCK ===== */}
                <div style={{
                    background: 'linear-gradient(135deg, #1a1f3a 0%, #2d1b4e 50%, #1a1f3a 100%)',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    marginBottom: '8px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(26, 31, 58, 0.3)'
                }}>
                    {/* Animated Background Elements */}
                    <div style={{
                        position: 'absolute',
                        top: '-50%',
                        right: '-10%',
                        width: '400px',
                        height: '400px',
                        background: 'radial-gradient(circle, rgba(102, 126, 234, 0.3) 0%, transparent 70%)',
                        borderRadius: '50%',
                        animation: 'float 6s ease-in-out infinite'
                    }} />
                    <div style={{
                        position: 'absolute',
                        bottom: '-30%',
                        left: '20%',
                        width: '300px',
                        height: '300px',
                        background: 'radial-gradient(circle, rgba(118, 75, 162, 0.3) 0%, transparent 70%)',
                        borderRadius: '50%',
                        animation: 'float 8s ease-in-out infinite reverse'
                    }} />

                    <div style={{ position: 'relative', zIndex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                {greeting.icon}
                                <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px', fontWeight: '500' }}>
                                    {greeting.text}
                                </span>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    background: 'rgba(16, 185, 129, 0.2)',
                                    padding: '2px 8px',
                                    borderRadius: '12px'
                                }}>
                                    <Circle className="live-indicator" style={{ fontSize: '6px', color: '#10b981' }} />
                                    <span style={{ color: '#10b981', fontSize: '9px', fontWeight: '600' }}>LIVE</span>
                                </div>
                            </div>
                            <h1 style={{ 
                                margin: '0 0 2px 0', 
                                fontSize: '18px', 
                                fontWeight: '800',
                                color: 'white',
                                letterSpacing: '-0.5px'
                            }}>
                                Welcome back, <span style={{ 
                                    background: 'linear-gradient(135deg, #667eea 0%, #a855f7 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent'
                                }}>{username}</span>! 
                            </h1>
                            <p style={{ margin: 0, color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>
                                {companyName} • {roleName}
                            </p>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {/* Live Clock */}
                            <div style={{
                                background: 'rgba(255,255,255,0.1)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '10px',
                                padding: '6px 10px',
                                border: '1px solid rgba(255,255,255,0.1)',
                                textAlign: 'center'
                            }}>
                                <div style={{ 
                                    fontSize: '20px', 
                                    fontWeight: '700', 
                                    color: 'white',
                                    fontFamily: 'monospace',
                                    letterSpacing: '1px'
                                }}>
                                    {currentTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                </div>
                                <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.6)', marginTop: '2px' }}>
                                    {currentTime.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
                                </div>
                            </div>



                            {/* Refresh */}
                            <Tooltip title="Refresh Dashboard">
                                <IconButton 
                                    onClick={fetchDashboardData}
                                    style={{
                                        background: 'rgba(255,255,255,0.1)',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255,255,255,0.1)'
                                    }}
                                >
                                    <Refresh style={{ color: 'white' }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>

                    {/* Quick Stats Bar */}
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        marginTop: '8px',
                        paddingTop: '8px',
                        borderTop: '1px solid rgba(255,255,255,0.1)'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <div style={{ 
                                width: '24px', 
                                height: '24px', 
                                borderRadius: '8px', 
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <CheckCircle style={{ color: 'white', fontSize: '14px' }} />
                            </div>
                            <div>
                                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Completed</div>
                                <div style={{ color: 'white', fontSize: '14px', fontWeight: '700' }}>{dashboardData.completedAppointments}</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <div style={{ 
                                width: '24px', 
                                height: '24px', 
                                borderRadius: '8px', 
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <PendingActions style={{ color: 'white', fontSize: '14px' }} />
                            </div>
                            <div>
                                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Pending</div>
                                <div style={{ color: 'white', fontSize: '14px', fontWeight: '700' }}>{dashboardData.pendingAppointments}</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <div style={{ 
                                width: '24px', 
                                height: '24px', 
                                borderRadius: '8px', 
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <People style={{ color: 'white', fontSize: '14px' }} />
                            </div>
                            <div>
                                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>New Patients</div>
                                <div style={{ color: 'white', fontSize: '14px', fontWeight: '700' }}>{dashboardData.newPatientsToday}</div>
                            </div>
                        </div>
                        
                        {(roleName === 'CompanyAdmin' || roleName === 'SuperAdmin') && (
                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: 'right' }}>Today's Revenue</div>
                                    <div style={{ 
                                        color: '#10b981', 
                                        fontSize: '14px', 
                                        fontWeight: '800',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}>
                                        {formatCurrency(dashboardData.todayRevenue)}
                                        <TrendingUp style={{ fontSize: '16px' }} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ===== MAIN STATS GRID ===== */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: (roleName === 'CompanyAdmin' || roleName === 'SuperAdmin') 
                        ? 'repeat(4, 1fr)' 
                        : 'repeat(3, 1fr)',
                    gap: '6px',
                    marginBottom: '6px'
                }}>
                    {/* Today's Appointments Card */}
                    <div 
                        className="stat-card glass-card"
                        onClick={() => history.push('/AppointmentIndex')}
                        style={{
                            borderRadius: '10px',
                            padding: '8px',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        <div style={{
                            position: 'absolute',
                            top: '-12px',
                            right: '-12px',
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #667eea20 0%, #764ba220 100%)',
                            borderRadius: '50%'
                        }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '6px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 3px 8px rgba(102, 126, 234, 0.3)'
                            }}>
                                <CalendarMonth style={{ color: 'white', fontSize: '14px' }} />
                            </div>
                            <div style={{
                                background: '#667eea15',
                                padding: '2px 6px',
                                borderRadius: '10px',
                                fontSize: '8px',
                                fontWeight: '600',
                                color: '#667eea',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px'
                            }}>
                                <TrendingUp style={{ fontSize: '10px' }} /> +12%
                            </div>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <p style={{ margin: '0 0 1px 0', fontSize: '9px', color: '#6b7280', fontWeight: '500' }}>Today's Appointments</p>
                            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#1f2937' }}>
                                {loading ? <CircularProgress size={16} /> : dashboardData.todayAppointments}
                            </h2>
                        </div>
                        <div style={{ marginTop: '2px' }}>
                            <LinearProgress 
                                variant="determinate" 
                                value={completionRate} 
                                style={{ height: '1.5px', borderRadius: '1px', background: '#e5e7eb' }}
                                sx={{ '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)', borderRadius: '1px' } }}
                            />
                            <p style={{ margin: '1px 0 0 0', fontSize: '7px', color: '#6b7280' }}>{completionRate}% completed</p>
                        </div>
                    </div>

                    {/* Total Patients Card */}
                    <div 
                        className="stat-card glass-card"
                        onClick={() => history.push('/PatientIndex')}
                        style={{
                            borderRadius: '10px',
                            padding: '8px',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        <div style={{
                            position: 'absolute',
                            top: '-12px',
                            right: '-12px',
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #10b98120 0%, #05966920 100%)',
                            borderRadius: '50%'
                        }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '6px',
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 3px 8px rgba(16, 185, 129, 0.3)'
                            }}>
                                <People style={{ color: 'white', fontSize: '16px' }} />
                            </div>
                            <div style={{
                                background: '#10b98115',
                                padding: '2px 6px',
                                borderRadius: '10px',
                                fontSize: '8px',
                                fontWeight: '600',
                                color: '#10b981',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px'
                            }}>
                                <PersonAdd style={{ fontSize: '10px' }} /> +{dashboardData.newPatientsToday}
                            </div>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <p style={{ margin: '0 0 1px 0', fontSize: '9px', color: '#6b7280', fontWeight: '500' }}>Total Patients</p>
                            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#1f2937' }}>
                                {loading ? <CircularProgress size={16} /> : dashboardData.totalPatients}
                            </h2>
                        </div>
                        <p style={{ margin: '2px 0 0 0', fontSize: '8px', color: '#10b981', fontWeight: '600' }}>
                            {dashboardData.newPatientsToday} new today
                        </p>
                    </div>

                    {/* Doctors Card */}
                    <div 
                        className="stat-card glass-card"
                        onClick={() => history.push('/DoctorIndex')}
                        style={{
                            borderRadius: '10px',
                            padding: '8px',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        <div style={{
                            position: 'absolute',
                            top: '-12px',
                            right: '-12px',
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #f59e0b20 0%, #d9770620 100%)',
                            borderRadius: '50%'
                        }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '6px',
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 3px 8px rgba(245, 158, 11, 0.3)'
                            }}>
                                <MedicalServices style={{ color: 'white', fontSize: '14px' }} />
                            </div>
                            <div style={{
                                background: '#f59e0b15',
                                padding: '2px 6px',
                                borderRadius: '10px',
                                fontSize: '8px',
                                fontWeight: '600',
                                color: '#f59e0b'
                            }}>
                                Active
                            </div>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <p style={{ margin: '0 0 1px 0', fontSize: '9px', color: '#6b7280', fontWeight: '500' }}>Total Doctors</p>
                            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#1f2937' }}>
                                {loading ? <CircularProgress size={16} /> : dashboardData.totalDoctors}
                            </h2>
                        </div>
                        <p style={{ margin: '2px 0 0 0', fontSize: '8px', color: '#6b7280' }}>
                            All doctors available
                        </p>
                    </div>

                    {/* Revenue Card - Only for CompanyAdmin and SuperAdmin */}
                    {(roleName === 'CompanyAdmin' || roleName === 'SuperAdmin') && (
                        <div 
                            className="stat-card glass-card"
                            style={{
                                borderRadius: '10px',
                                padding: '8px',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                        >
                            <div style={{
                                position: 'absolute',
                                top: '-12px',
                                right: '-12px',
                                width: '50px',
                                height: '50px',
                                background: 'linear-gradient(135deg, #ef444420 0%, #dc262620 100%)',
                                borderRadius: '50%'
                            }} />
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                                <div style={{
                                    width: '24px',
                                    height: '24px',
                                    borderRadius: '6px',
                                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 3px 8px rgba(239, 68, 68, 0.3)'
                                }}>
                                    <AttachMoney style={{ color: 'white', fontSize: '14px' }} />
                                </div>
                                <div style={{
                                    background: '#10b98115',
                                    padding: '2px 6px',
                                    borderRadius: '10px',
                                    fontSize: '8px',
                                    fontWeight: '600',
                                    color: '#10b981',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '2px'
                                }}>
                                    <TrendingUp style={{ fontSize: '10px' }} /> +8%
                                </div>
                            </div>
                            <div style={{ position: 'relative', zIndex: 1 }}>
                                <p style={{ margin: '0 0 1px 0', fontSize: '9px', color: '#6b7280', fontWeight: '500' }}>Monthly Revenue</p>
                                <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#1f2937' }}>
                                    {loading ? <CircularProgress size={16} /> : formatCurrency(dashboardData.monthlyRevenue)}
                                </h2>
                            </div>
                            <p style={{ margin: '2px 0 0 0', fontSize: '8px', color: '#6b7280' }}>
                                Today: {formatCurrency(dashboardData.todayRevenue)}
                            </p>
                        </div>
                    )}
                </div>

                {/* ===== MAIN CONTENT GRID ===== */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr',
                    gap: '8px'
                }}>
                    {/* Left Column */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {/* Quick Actions */}
                        <div className="glass-card" style={{ borderRadius: '12px', padding: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Bolt style={{ color: '#667eea', fontSize: '18px' }} /> Quick Actions
                                </h3>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '6px' }}>
                                {[
                                    { title: 'New Appointment', icon: <CalendarMonth />, link: '/AppointmentIndex', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
                                    { title: 'Add Patient', icon: <PersonAdd />, link: '/PatientIndex', gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' },
                                    { title: 'Doctor Entry', icon: <MedicalServices />, link: '/DoctorEntryIndex', gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' },
                                    { title: 'Treatments', icon: <LocalHospital />, link: '/TreatmentDashboard', gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' },
                                ].map((action, index) => (
                                    <Link 
                                        key={index}
                                        to={action.link}
                                        className="quick-action"
                                        style={{
                                            textDecoration: 'none',
                                            background: action.gradient,
                                            borderRadius: '10px',
                                            padding: '6px 4px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '4px',
                                            color: 'white',
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)'
                                        }}
                                    >
                                        <div style={{
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '8px',
                                            background: 'rgba(255,255,255,0.2)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            {action.icon}
                                        </div>
                                        <span style={{ fontSize: '10px', fontWeight: '600', textAlign: 'center' }}>{action.title}</span>
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* Today's Appointments Table */}
                        <div className="glass-card" style={{ borderRadius: '12px', padding: '10px', flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Schedule style={{ color: '#667eea', fontSize: '18px' }} /> Today's Schedule
                                </h3>
                                <Link to="/AppointmentIndex" style={{ 
                                    textDecoration: 'none', 
                                    color: '#667eea', 
                                    fontSize: '11px', 
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '2px'
                                }}>
                                    View All <KeyboardArrowRight style={{ fontSize: '16px' }} />
                                </Link>
                            </div>

                            {loading ? (
                                <div style={{ textAlign: 'center', padding: '24px' }}>
                                    <CircularProgress size={24} />
                                </div>
                            ) : recentAppointments.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    {recentAppointments.map((apt, index) => (
                                        <div 
                                            key={index}
                                            className="appointment-row"
                                            onClick={() => apt.Id && history.push(`/DoctorEntryCreateIds/${apt.Id}`)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '6px 8px',
                                                background: '#f9fafb',
                                                borderRadius: '8px',
                                                border: '1px solid #e5e7eb'
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <Avatar style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    fontSize: '12px',
                                                    fontWeight: '700'
                                                }}>
                                                    {apt.PatientName?.charAt(0) || 'P'}
                                                </Avatar>
                                                <div>
                                                    <p style={{ margin: 0, fontWeight: '600', fontSize: '12px', color: '#1f2937' }}>
                                                        {apt.PatientName || 'Patient'}
                                                    </p>
                                                    <p style={{ margin: '2px 0 0 0', fontSize: '10px', color: '#6b7280' }}>
                                                        Dr. {apt.DoctorName || 'Doctor'} • {apt.TreatmentName || 'Consultation'}
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <div style={{
                                                    background: `${getStatusColor(apt.Status)}15`,
                                                    color: getStatusColor(apt.Status),
                                                    padding: '4px 10px',
                                                    borderRadius: '12px',
                                                    fontSize: '9px',
                                                    fontWeight: '600',
                                                    textTransform: 'capitalize'
                                                }}>
                                                    {apt.Status || 'Scheduled'}
                                                </div>
                                                <div style={{
                                                    background: '#667eea15',
                                                    padding: '6px 10px',
                                                    borderRadius: '8px',
                                                    fontSize: '11px',
                                                    fontWeight: '700',
                                                    color: '#667eea',
                                                    minWidth: '60px',
                                                    textAlign: 'center'
                                                }}>
                                                    {apt.AppointmentTime || '00:00'}
                                                </div>
                                                <IconButton size="small" style={{ color: '#667eea', padding: '4px' }}>
                                                    <PlayArrow style={{ fontSize: '18px' }} />
                                                </IconButton>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '20px 12px',
                                    background: '#f9fafb',
                                    borderRadius: '10px'
                                }}>
                                    <CalendarMonth style={{ fontSize: '40px', color: '#d1d5db', marginBottom: '8px' }} />
                                    <p style={{ margin: 0, fontWeight: '600', color: '#6b7280', fontSize: '12px' }}>No appointments today</p>
                                    <p style={{ margin: '4px 0 0 0', fontSize: '10px', color: '#9ca3af' }}>Schedule appointments to see them here</p>
                                    <Link 
                                        to="/AppointmentIndex"
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            marginTop: '12px',
                                            padding: '8px 16px',
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            color: 'white',
                                            borderRadius: '8px',
                                            textDecoration: 'none',
                                            fontSize: '11px',
                                            fontWeight: '600'
                                        }}
                                    >
                                        <Add style={{ fontSize: '16px' }} /> New Appointment
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right Column */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {/* Upcoming Appointments */}
                        <div className="glass-card" style={{ borderRadius: '12px', padding: '10px' }}>
                            <h3 style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: '700', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <AccessTime style={{ color: '#f59e0b', fontSize: '18px' }} /> Up Next
                            </h3>
                            {upcomingAppointments.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {upcomingAppointments.map((apt, index) => (
                                        <div 
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '8px',
                                                background: index === 0 ? 'linear-gradient(135deg, #667eea10 0%, #764ba210 100%)' : '#f9fafb',
                                                borderRadius: '10px',
                                                border: index === 0 ? '1.5px solid #667eea30' : '1px solid #e5e7eb'
                                            }}
                                        >
                                            <div style={{
                                                width: '28px',
                                                height: '28px',
                                                borderRadius: '8px',
                                                background: index === 0 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#e5e7eb',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: index === 0 ? 'white' : '#6b7280',
                                                fontWeight: '700',
                                                fontSize: '11px'
                                            }}>
                                                {apt.PatientName?.charAt(0) || 'P'}
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <p style={{ margin: 0, fontWeight: '600', fontSize: '11px', color: '#1f2937' }}>
                                                    {apt.PatientName || 'Patient'}
                                                </p>
                                                <p style={{ margin: '1px 0 0 0', fontSize: '9px', color: '#6b7280' }}>
                                                    {apt.AppointmentTime || '00:00'}
                                                </p>
                                            </div>
                                            {index === 0 && (
                                                <div style={{
                                                    background: '#f59e0b',
                                                    color: 'white',
                                                    padding: '3px 6px',
                                                    borderRadius: '5px',
                                                    fontSize: '8px',
                                                    fontWeight: '700'
                                                }}>
                                                    NEXT
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '16px', color: '#6b7280' }}>
                                    <AccessTime style={{ fontSize: '24px', opacity: 0.3 }} />
                                    <p style={{ margin: '6px 0 0 0', fontSize: '11px' }}>No upcoming appointments</p>
                                </div>
                            )}
                        </div>

                        {/* Recent Patients */}
                        <div className="glass-card" style={{ borderRadius: '12px', padding: '10px', flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <People style={{ color: '#10b981', fontSize: '18px' }} /> Recent Patients
                                </h3>
                                <Link to="/PatientIndex" style={{ textDecoration: 'none', color: '#667eea', fontSize: '10px', fontWeight: '600' }}>
                                    View All
                                </Link>
                            </div>
                            {recentPatients.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    {recentPatients.map((patient, index) => (
                                        <div 
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '8px',
                                                background: '#f9fafb',
                                                borderRadius: '8px'
                                            }}
                                        >
                                            <Avatar style={{
                                                width: '28px',
                                                height: '28px',
                                                background: `hsl(${index * 60}, 70%, 60%)`,
                                                fontSize: '12px'
                                            }}>
                                                {patient.Name?.charAt(0) || 'P'}
                                            </Avatar>
                                            <div style={{ flex: 1 }}>
                                                <p style={{ margin: 0, fontWeight: '600', fontSize: '11px', color: '#1f2937' }}>
                                                    {patient.Name || 'Patient'}
                                                </p>
                                                <p style={{ margin: '1px 0 0 0', fontSize: '9px', color: '#6b7280' }}>
                                                    {patient.ContactNumber1 || 'No phone'}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '16px', color: '#6b7280' }}>
                                    <People style={{ fontSize: '24px', opacity: 0.3 }} />
                                    <p style={{ margin: '6px 0 0 0', fontSize: '11px' }}>No recent patients</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    position: 'fixed',
                    bottom: '16px',
                    right: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 16px',
                    background: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '14px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    fontFamily: 'serif',
                    fontWeight: 'bold',
                    color: '#2c3e50',
                    fontSize: '12px',
                    backdropFilter: 'blur(10px)'
                }}>
                    <CopyrightIcon style={{ fontSize: '16px', color: '#667eea' }} />
                    <b>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div>
        </Fade>
    );
};

export default withSessionCheck(Home);
